import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 bg-background-50">
          <h2 className="absolute bottom-1/3 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0 font-heading">
            404
          </h2>
          <div className="relative z-10">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-6">
              页面未找到
            </h1>
            <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
            <p className="mt-4 text-foreground-600 text-sm md:text-base">
              你访问的页面不存在，可能已被移除或地址输入有误。
            </p>
            <Link
              to="/"
              className="inline-flex items-center mt-6 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              返回首页
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}